import type { ItemProps } from "@bedrock/domain";
import { IconButton } from "@bedrock/ui";
import { copyAssetFile, type CopyFileToClipboard } from "./asset-clipboard";

export type CopyableAssetProps = Extract<ItemProps, { kind: "image" | "video" | "pdf" | "spreadsheet" }>;

export function AssetCopyButton({ props, copyFileToClipboard }: { props: CopyableAssetProps; copyFileToClipboard: CopyFileToClipboard | undefined }) {
  if (!copyFileToClipboard) return null;
  const copy = () => {
    if (!props.localUrl) return;
    void copyAssetFile({ source: props.localUrl, filename: props.filename, mimeType: props.mimeType }, copyFileToClipboard)
      .catch((error: unknown) => console.error("Asset file copy failed", error));
  };
  return <IconButton label="Copy file" icon="copy" onClick={copy} disabled={!props.localUrl}/>;
}
